// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2g-1";
export var movingGradient = "_2g-4";
export var movingGradientBlock = "_2g-2";
export var skeleton = "_2g-0";
export var skeletonText = "_2g-3";